<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="col xl:col-12 lg:col-12 md:col-12 sm:col-12 xs:col-12 p-2">
    <div class="shadow-2 surface-card border-round p-4 h-full">
        <div class="flex align-items-start mb-5 grid">
            <div class="ml-3 col-fixed">
                <span class="block text-900 mb-1 text-xl font-medium"
                    >Send Hours</span>
            </div>
            <div class="col-12" style="text-align: center;">
                <p-message
                    severity="info"
                    text='Send hours populates the QuickBooks timesheets with approved hours for the selected date range.   The user list contains all persons with approved time not yet sent to QuickBooks for the selected date range.  Approved time includes 0 hours entered to remove a time entry.'
                ></p-message>
            </div>
        </div>
        <div class="ml-3">
            <ef-send-hours-filter
                [EndDate]="endDate$ | async"
                [StartDate]="startDate$ | async"
                [SendDocumentation]="sendDoctoQB$ | async"
                (Filter)="onFilter($event)"
                (SetSendDocumentation)="onSetSendDocumentation($event)"
            >
            </ef-send-hours-filter>

            <p-messages></p-messages>

            <ef-send-hours-presenter
                [items]="employeesWithHours$ | async"
                (SendHours)="onSendHours($event)"
            ></ef-send-hours-presenter>
            <div *ngIf="false">
                <ef-send-bill-presenter
                    [items]="contractorsWithHours$ | async"
                    (SendBills)="onSendBills($event)"
                ></ef-send-bill-presenter>
            </div>
        </div>
    </div>
</div>
